import React from "react";

function MissionAndVisionWrapper() {
  return (
    <div>
      <section className="mission-vision-wrapper bg-white">
        <div className="divider"></div>

        <div className="container">
          <div className="row g-5 g-md-4 align-items-center">
            {/* Mission Vision Image */}
            <div className="col-12 col-md-6">
              <div className="mission-vision-img-container">
                <img src="assets/img/bg-img/19.jpg" alt="" />

                {/* Experience */}
                <div className="experience">
                  <h3 className="mb-0">20+</h3>
                  <span>Years Experience</span>
                </div>
              </div>
            </div>

            {/* Mission Vision Content */}
            <div className="col-12 col-md-6">
              <div className="mission-vision-content">
                {/* Section Heading */}
                <div className="section-heading">
                  <div className="sub-title">
                    <img src="assets/img/core-img/hammer.png" alt="" />
                    About Us
                  </div>
                  <h2 className="mb-4">Commitment to Justice Through Truth</h2>
                  <p className="mb-5">
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem ipsum has been the standard
                    dummy. With passion for innovation and a commitment to
                    excellence.
                  </p>
                </div>

                <div className="mission-vision-accordion">
                  <div className="accordion" id="missionVision">
                    {/* Accordion */}
                    <div className="accordion-item">
                      <div className="accordion-header">
                        <button
                          className="accordion-button"
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            const btn = e.currentTarget;
                            const target =
                              document.getElementById("collapseOne");
                            if (!target) return;

                            const isOpen = target.classList.contains("show");

                            // OPTIONAL: only-one-open behavior (mimics data-bs-parent)
                            const parent =
                              document.getElementById("missionVision");
                            if (!isOpen && parent) {
                              parent
                                .querySelectorAll(".accordion-collapse.show")
                                .forEach((el) => {
                                  el.style.height = el.scrollHeight + "px";
                                  requestAnimationFrame(
                                    () => (el.style.height = "0px")
                                  );
                                  setTimeout(() => {
                                    el.classList.remove("show");
                                    el.style.height = "";
                                  }, 350);
                                  const headerBtn =
                                    el.parentElement?.querySelector(
                                      ".accordion-button"
                                    );
                                  if (headerBtn) {
                                    headerBtn.classList.add("collapsed");
                                    headerBtn.setAttribute(
                                      "aria-expanded",
                                      "false"
                                    );
                                  }
                                });
                            }

                            if (isOpen) {
                              // close
                              target.style.height = target.scrollHeight + "px";
                              requestAnimationFrame(
                                () => (target.style.height = "0px")
                              );
                              setTimeout(() => {
                                target.classList.remove("show");
                                target.style.height = "";
                              }, 350);
                              btn.classList.add("collapsed");
                              btn.setAttribute("aria-expanded", "false");
                            } else {
                              // open
                              target.classList.add("show");
                              target.style.height = "0px";
                              requestAnimationFrame(
                                () =>
                                  (target.style.height =
                                    target.scrollHeight + "px")
                              );
                              setTimeout(() => {
                                target.style.height = "";
                              }, 350);
                              btn.classList.remove("collapsed");
                              btn.setAttribute("aria-expanded", "true");
                            }
                          }}
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          Our Mission
                        </button>
                      </div>

                      <div
                        id="collapseOne"
                        className="accordion-collapse collapse show"
                        style={{
                          transition: "height 0.35s ease",
                          overflow: "hidden",
                        }}
                      >
                        <div className="accordion-body">
                          Etiam id justo vitae lacus hendrerit ornare sit amet
                          in justo. Donec non felis tempus augue malesuada
                          accumsan non nisl. Embrace growth with dynamic
                          vitality.
                        </div>
                      </div>
                    </div>

                    {/* Accordion */}
                    <div className="accordion-item">
                      <div className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            const btn = e.currentTarget;
                            const target =
                              document.getElementById("collapseTwo");
                            if (!target) return;

                            const isOpen = target.classList.contains("show");

                            // Only-one-open behavior under #missionVision
                            const parent =
                              document.getElementById("missionVision");
                            if (!isOpen && parent) {
                              parent
                                .querySelectorAll(".accordion-collapse.show")
                                .forEach((el) => {
                                  if (el === target) return;
                                  el.style.height = el.scrollHeight + "px";
                                  requestAnimationFrame(
                                    () => (el.style.height = "0px")
                                  );
                                  setTimeout(() => {
                                    el.classList.remove("show");
                                    el.style.height = "";
                                  }, 350);
                                  const headerBtn =
                                    el.parentElement?.querySelector(
                                      ".accordion-button"
                                    );
                                  if (headerBtn) {
                                    headerBtn.classList.add("collapsed");
                                    headerBtn.setAttribute(
                                      "aria-expanded",
                                      "false"
                                    );
                                  }
                                });
                            }

                            if (isOpen) {
                              // close
                              target.style.height = target.scrollHeight + "px";
                              requestAnimationFrame(
                                () => (target.style.height = "0px")
                              );
                              setTimeout(() => {
                                target.classList.remove("show");
                                target.style.height = "";
                              }, 350);
                              btn.classList.add("collapsed");
                              btn.setAttribute("aria-expanded", "false");
                            } else {
                              // open
                              target.classList.add("show");
                              target.style.height = "0px";
                              requestAnimationFrame(
                                () =>
                                  (target.style.height =
                                    target.scrollHeight + "px")
                              );
                              setTimeout(() => {
                                target.style.height = "";
                              }, 350);
                              btn.classList.remove("collapsed");
                              btn.setAttribute("aria-expanded", "true");
                            }
                          }}
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          Our Vision
                        </button>
                      </div>

                      <div
                        id="collapseTwo"
                        className="accordion-collapse collapse"
                        style={{
                          transition: "height 0.35s ease",
                          overflow: "hidden",
                        }}
                      >
                        <div className="accordion-body">
                          Etiam id justo vitae lacus hendrerit ornare sit amet
                          in justo. Donec non felis tempus augue malesuada
                          accumsan non nisl. Embrace growth with dynamic
                          vitality.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default MissionAndVisionWrapper;
